import { CardLabels, CardIcons } from '../../consts/client-detail';

export type CardType = keyof typeof CardIcons | 'unknown';

export function useCardIconByType(type: CardType) {
  const Icon = CardIcons[type as keyof typeof CardIcons] ?? null;
  const label = CardLabels[type as keyof typeof CardLabels] ?? CardLabels.unknown;
  return { Icon, label };
}
